import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { routes } from './app.routes';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { coreInterceptor } from '@core/interceptor/core.interceptor';
import { ProjectService } from '@core/services/project/project.service';
import { AuthService } from '@core/services/auth/auth.service';
import { ThemeService } from '@shared/services/theme/theme.service';
import { MessageService } from 'primeng/api';
import { SvgIconComponent } from '@ngneat/svg-icon';
import { svgIconProviders } from './app.registory';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideAnimationsAsync(),
    provideHttpClient(withInterceptors([coreInterceptor])),
    ProjectService,
    AuthService,
    ThemeService,
    MessageService,
    SvgIconComponent,
    ...svgIconProviders,
  ],
};
